module.exports = __webpack_public_path__ + "img/product_125.cad1cd8.webp";